// removed by extract-text-webpack-plugin
module.exports = {"address-item":"address-item","address-item__title":"address-item__title","comment":"comment","address-block__items":"address-block__items","address-block__main-item":"address-block__main-item","address-block__left-pad":"address-block__left-pad","address-block__phone":"address-block__phone","address-block__left":"address-block__left","address-block__right":"address-block__right","address-block__right-descr":"address-block__right-descr","address-block__link-sell":"address-block__link-sell","address-block__link-wrap":"address-block__link-wrap","address-block":"address-block","address-block__item":"address-block__item"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_address.scss
// module id = 263
// module chunks = 0